"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isExperimentEnabled;

var _apiHelper = _interopRequireDefault(require("./api-helper"));

function isExperimentEnabled(experimentName) {
  return _apiHelper["default"].get("/experiments/".concat(experimentName)).then(function (experiment) {
    return experiment.enabled || false;
  });
}